// dashboard/frontend/src/utils/squareConfig.js
export const squareConfig = {
    applicationId: process.env.REACT_APP_SQUARE_APP_ID,
    locationId: process.env.REACT_APP_SQUARE_LOCATION_ID,
    environment: process.env.NODE_ENV === 'production' ? 'production' : 'sandbox'
};

// For debugging
console.log('Square Config:', {
    applicationId: process.env.REACT_APP_SQUARE_APP_ID ? 'Set' : 'Missing',
    locationId: process.env.REACT_APP_SQUARE_LOCATION_ID ? 'Set' : 'Missing',
    environment: process.env.NODE_ENV === 'production' ? 'production' : 'sandbox'
});